import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {delay, takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {TerminalsImportRow} from "../../../../shared/interface/terminals-import-row";
import {TerminalsImportRowService} from "../../../../shared/services/terminals-import-row.service";
import {Partner} from "../../../../shared/interface/partner";


export interface ChangePartnerFacilityDialogData {
  terminalsObject: TerminalsImportRow;
}

@Component({
  selector: 'app-change-partner-facility-dialog',
  templateUrl: './change-partner-facility-dialog.component.html',
  styleUrls: ['./change-partner-facility-dialog.component.scss']
})
export class ChangePartnerFacilityDialogComponent implements OnInit, OnDestroy  {

  changePartenrFacilityForm: FormGroup;
  terminalsObject: TerminalsImportRow;
  processingRequest = false;
  partnerControl: FormControl;
  partnerFacilityControl: FormControl;
  enableSaveButton = false;
  enableFacility = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<ChangePartnerFacilityDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChangePartnerFacilityDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private terminalsImportsRowService: TerminalsImportRowService,
    private snack: MatSnackBar
  ) {
    this.terminalsObject = data.terminalsObject;
    this.partnerControl = fb.control('', [Validators.required ]),
    this.changePartenrFacilityForm = fb.group({
      partnerFacility: this.partnerFacilityControl = fb.control('', [Validators.required ]),
    });
  }

  ngOnInit(): void {
    this.changePartenrFacilityForm.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.enableSaveButton = this.changePartenrFacilityForm.valid);
    this.partnerControl.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe((partner: Partner) =>
        {
          this.partnerFacilityControl.reset();
          if (partner) {
            this.enableFacility = !this.enableFacility;
          }
        }
      );
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  sendForm(): void {
    this.processingRequest = true;

    this.terminalsImportsRowService.changePartnerFacility(this.changePartenrFacilityForm.value, this.terminalsObject.uuid)
      .subscribe(() => {
        this.snack.open('Pomyślnie zmieniono placówkę', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas aktualizacji obiektu polisy wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });


      })
    ;
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }
}

